import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './fonts/fonts.scss'
import './i18n';
import { Provider } from 'react-redux';
import configureStore from './redux/configureStore'


const store = configureStore();

export const fisWidget = {
  new: config => {
      return {
          render: () => {
            ReactDOM.render(
              <Provider store={store}>
                <React.StrictMode>
                  <App config={config} />
                </React.StrictMode>
              </Provider>,
              document.querySelector(config.selector)
            );
          },
      };
  },
};

//Only for dev
/*
let config = {};
config.selector='#findStoreApp';
config.data = {};
config.data.frame = {};
const myWidget = fisWidget.new(config);
myWidget.render();
*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

